export default __webpack_public_path__ + "static/media/EM0110.34I-19689_-23283_0.2cd40ebb.jpg";